import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import BookConfirmationInfo from "@/components/book/BookConfirmationInfo.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import MapOfBusStop from "@/views/map/MapOfBusStop.vue";
import Modal from "@/components/shared/modal/base/Modal.vue";
import { IBookResultInfo } from "@/domain/entities/book";
import { IBusStopData } from "@/domain/entities/busStop";
import { useLineStore } from "@/stores/lineStore";
import { useBookStore } from "@/stores/bookStore";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import { BookIntervalCode, RouterName } from "@/types";
import { IBookResultDetailInfo } from "@/repositories/book/parsers/bookResultInfoParser";
import MultipleBookDateSeats from "@/components/book/MultipleBookDateSeats.vue";
import SingleBookDateSeats from "@/components/book/SingleBookDateSeats.vue";
import BookConfirmationTotalAmount from "@/components/book/BookConfirmationTotalAmount.vue";
import InlineSvg from "vue-inline-svg";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "BookConfirmation",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

dayjs.locale("ko");
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Seoul");

const router = useRouter();
const route = useRoute();

const lineStore = useLineStore();
const bookStore = useBookStore();

const bookResult = ref<IBookResultInfo | undefined>();
const successBoardingDates = ref<IBookResultDetailInfo[]>([]);
const failedBoardingDates = ref<IBookResultDetailInfo[]>([]);

const onClickConfirm = () => {
  router.replace({ name: RouterName.MainLogin });
};

const selectedBusStop = ref<IBusStopData | undefined>(undefined);
const shouldShowMap = ref(false);
const toggleShowMap = (show: boolean) => {
  shouldShowMap.value = show;
};

const onClickBusStopLocation = (busStopId: string) => {
  selectedBusStop.value = lineStore.getBusStopById(busStopId);
  toggleShowMap(true);
};

/** 실패한 예약 보여주는 팝업 처리 */
const shouldShowBookFailedModal = ref(false);
const bookFaileModalTitle = ref("예약 실패");
const bookFailedDates = ref("");
const bookFailedReasons = ref("");

const showBookFailedModal = () => {
  const isAllFailed =
    failedBoardingDates.value.length && !successBoardingDates.value.length;
  bookFaileModalTitle.value = isAllFailed ? "예약 실패" : "부분 예약 실패";
  bookFailedDates.value = getFailedBookDatesMessage();
  bookFailedReasons.value = getFailedReasons().join(", ");
  shouldShowBookFailedModal.value = true;
};

const hideBookFailedModal = () => {
  shouldShowBookFailedModal.value = false;
  // const isAllFailed = failedBoardingDates.value.length === bookInfos.value.length;
  // if (isAllFailed) {
  //   router.push({ name: RouterName.MainLogin });
  // }
};

// Date Format: "2022-08-10"
const getFailedBookDatesMessage = () => {
  const failedBookInfoDates = failedBoardingDates.value.map(
    (failedBookInfo) => failedBookInfo.boardDate
  );
  let datesMessage = failedBookInfoDates[0];
  let year = datesMessage.split("-")[0];
  let month = datesMessage.split("-")[1];

  failedBookInfoDates.forEach((date, index) => {
    if (index === 0) {
      return;
    }
    const yearOfDate = date.split("-")[0];
    const monthOfDate = date.split("-")[1];
    if (year === yearOfDate && month === monthOfDate) {
      datesMessage += ", " + date.split("-")[2];
      return;
    }
    datesMessage += " / " + date;
    year = yearOfDate;
    month = monthOfDate;
  });
  return datesMessage;
};

const getFailedReasons = () => {
  const reasons = failedBoardingDates.value.map(
    (bookInfo) => bookInfo.bookFailedReason
  );
  return Array.from(new Set(reasons));
};

const isFetchedBookResultInfo = ref(false);
const getBookResultInfo = async () => {
  const { bookUid } = route.query as {
    bookUid: string;
  };
  const bookResultInfoResult = await bookStore.getBookResultInfo(bookUid);

  isFetchedBookResultInfo.value = true;

  if (!bookResultInfoResult.isSuccess) return;

  bookResult.value = bookResultInfoResult.data;

  successBoardingDates.value =
    bookResult.value?.boardingDates?.filter(
      (bookDetail) => bookDetail.bookSuccess
    ) ?? [];

  failedBoardingDates.value =
    bookResult.value?.boardingDates?.filter(
      (bookDetail) => !bookDetail.bookSuccess
    ) ?? [];

  if (failedBoardingDates.value.length) {
    showBookFailedModal();
  }
};

onMounted(async () => {
  await getBookResultInfo();
});

const __returned__ = { router, route, lineStore, bookStore, bookResult, successBoardingDates, failedBoardingDates, onClickConfirm, selectedBusStop, shouldShowMap, toggleShowMap, onClickBusStopLocation, shouldShowBookFailedModal, bookFaileModalTitle, bookFailedDates, bookFailedReasons, showBookFailedModal, hideBookFailedModal, getFailedBookDatesMessage, getFailedReasons, isFetchedBookResultInfo, getBookResultInfo, BookConfirmationInfo, FooterButton, MapOfBusStop, Modal, get BookIntervalCode() { return BookIntervalCode }, MultipleBookDateSeats, SingleBookDateSeats, BookConfirmationTotalAmount, get InlineSvg() { return InlineSvg }, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})